import { Col, Container, Row, Stack } from "react-bootstrap";
import { renderSortIcon } from "../helperRenders";

export default function SongScoresHeader({ sortConfig, requestSort }) {
    return (
        <Container fluid className="sticky-top">
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 rounded-2 fs-8-xs table-header user-select-none h-100">
                <Col onClick={() => requestSort("song.artist")} className=" align-content-center">
                    <Stack direction="horizontal">
                        <span>Artist</span>
                        <span className="col-1">{renderSortIcon("song.artist", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col onClick={() => requestSort("song.title")} className=" align-content-center">
                    <Stack direction="horizontal">
                        <span>Title</span>
                        <span className="col-1">{renderSortIcon("song.title", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={2} onClick={requestSort ? () => requestSort("song.release_year") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">Release Year</span>
                        <span className="col-1">{renderSortIcon("song.release_year", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={2} xl={1} onClick={requestSort ? () => requestSort("music_test_data.song_score") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">Score</span>
                        <span className="col-1">{renderSortIcon("music_test_data.song_score", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={2} xl={1} onClick={requestSort ? () => requestSort("music_test_data.song_score_trend") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">Trend</span>
                        <span className="col-1">{renderSortIcon("music_test_data.song_score_trend", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={2} onClick={requestSort ? () => requestSort("music_test_data.first_play") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">First Played</span>
                        <span className="col-1">{renderSortIcon("music_test_data.first_play", sortConfig)}</span>
                    </Stack>
                </Col>
            </Row>
        </Container>
    );
}
